// Fecha desde la que se cuentan las semanas de una cohorte.
//
// Cohortes con `first_session_after_start` (creadas desde 2026-10-01): la
// sesión de la semana N cae en inicio + N × periodicidad, así que la semana 1
// va del día 1 al 7 tras el inicio y su sesión es el último día de la semana.
// Para eso las semanas se cuentan desde inicio + 1 día. Las cohortes previas
// cuentan desde el inicio (semana 1 = días 0–6), como siempre.
export function weekAnchorDate(
  startDate: string | null | undefined,
  firstSessionAfterStart: boolean | null | undefined,
): string | null {
  if (!startDate) return null;
  if (!firstSessionAfterStart) return startDate;
  const [y, m, d] = startDate.slice(0, 10).split('-').map(Number);
  const anchor = new Date(y, m - 1, d + 1);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${anchor.getFullYear()}-${pad(anchor.getMonth() + 1)}-${pad(anchor.getDate())}`;
}

// Semana académica actual (1-based) contando días por fecha local, igual que
// el panel del participante. Devuelve 0 si la cohorte aún no inicia.
export function currentCohortWeek(anchorDate: string | null | undefined, now: Date = new Date()): number {
  if (!anchorDate) return 0;
  const [y, m, d] = anchorDate.slice(0, 10).split('-').map(Number);
  const start = new Date(y, m - 1, d);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.round((today.getTime() - start.getTime()) / 86400000);
  if (diffDays < 0) return 0;
  return Math.floor(diffDays / 7) + 1;
}
